import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SurveyStatus } from '@ps/survey-kernel';
import { BulkOperationType, BulkStats, Survey } from '@ps/survey-utils';
import { Nullable } from '@ps/utils';

export const BulkEditActions = createActionGroup({
  source: 'Bulk Edit',
  events: {
    'Set Selected Surveys': props<{ selected: Survey[] }>(),
    'Reset Selected Surveys': emptyProps(),
    'Set Bulk Operation': props<{ operation: BulkOperationType }>(),
    'Bulk Patch Values': props<{
      operation: BulkOperationType;
      operationLabel: string;
    }>(),
    'Launch Tc Replica': props<{ operationLabel: string }>(),
    'Check Surveys With Matching Billing ID': props<{ billingId: string }>(),
    'Validate Billing ID': props<{
      billingId: string;
    }>(),
    'Validate High Cpi On Status Change': props<{
      status: SurveyStatus;
    }>(),
    'Get Supplier Summary Report': props<{
      email: string;
      surveys: Survey[];
    }>(),
    'Group Surveys': props<{ groupTitle: string; operationLabel: string }>(),
    'Delete Draft': props<{ operationLabel: string }>(),
  },
});

export const BulkEditApiActions = createActionGroup({
  source: 'Bulk Edit API',
  events: {
    'Load Bulk Stats Success': props<{ stats: Nullable<BulkStats> }>(),
    'Bulk Patch Values Success': emptyProps(),
    'Bulk Patch Values Failure': props<{ error: string }>(),
    'Launch Tc Replica Success': emptyProps(),
    'Launch Tc Replica Failure': props<{ error: string }>(),
    'Check Surveys With Matching Billing ID Success': emptyProps(),
    'Check Surveys With Matching Billing ID Failure': emptyProps(),
    'Validate Billing ID Success': emptyProps(),
    'Validate Billing ID Failure': emptyProps(),
    'Validate High Cpi On Status Change Success': emptyProps(),
    'Validate High Cpi On Status Change Failure': emptyProps(),
    'Download Supplier Summary Report Success': emptyProps(),
    'Download Supplier Summary Report Failure': emptyProps(),
    'Group Surveys Success': emptyProps(),
    'Group Surveys Failure': props<{ error: string }>(),
    'Delete Draft Success': emptyProps(),
    'Delete Draft Failure': props<{ error: string }>(),
  },
});
